module.exports = __webpack_public_path__ + "static/media/passport.690b58d7.svg";